import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/training/')({
    beforeLoad: ({ params }): never => {
        throw redirect({
            to: '/console/$orgId/configuration/compliance/training/training-periods',
            params,
            replace: true,
        });
    },
});
